import {
    FIND_TABLE_CONFIGS_REQUEST,
    findTableConfigsSuccess,
    findTableConfigsFailure
} from 'Redux/Action';
import { ofType }      from 'redux-observable';
import { EMPTY, from } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';

export function findTableConfigsEpic(action$, store$, { TableRepository }) {
    return action$.pipe(
      ofType( FIND_TABLE_CONFIGS_REQUEST ),
      mergeMap( action =>{
          const { id } = action.payload;

          if(!`${id || ''}`.trim()) {
              return EMPTY;
          }

          return from(
            TableRepository.findById( id )
              .then(findTableConfigsSuccess)
              .catch(findTableConfigsFailure),
          );
      }),
    );
}
